import { common } from './common';

export const environment = {
  production: false,
  environmentType: 'development',
  mf: 'manifest.local.json',
  websocket: 'http://localhost:8025/api/websocket',
  urlApiCore: 'http://localhost:8025',
  urlApiBidData: 'http://localhost:8026',
  urlApiBalance: 'http://localhost:8031',
  urlApiPrint: 'https://report-api-dev.linkapital.com.br',
  urlApiSaaS: 'http://localhost:8028',
  ...common
};
